var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightbracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 85,
    viewBox: "0 0 29 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6765 17.1669C15.6765 17.1669 15.8302 -1.02467 0 0.0454244C0.461073 1.87987 4.91812 12.2751 15.6765 17.1669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 31.6896C30.8919 14.721 17.2134 5.8545 17.2134 5.8545C16.906 11.5107 18.904 19.9186 19.8262 22.2116C21.0557 25.5748 21.6704 28.4793 22.9 31.6896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9718 29.3966C31.1993 51.5628 22.2852 52.6329 22.2852 52.6329L22.9 43.9193C23.5147 34.1355 26.8959 30.7724 27.9718 29.3966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45503 17.1669C20.902 16.5554 19.6724 33.8298 19.5188 33.5241C18.4429 31.6896 13.0637 27.4092 13.0637 27.5621C7.99192 23.8932 7.53087 17.9313 6.45503 17.1669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.908 33.0654C25.359 39.0274 19.6724 51.7157 19.6724 51.7157C15.9838 45.6008 16.1376 45.9066 15.2154 43.002C14.1396 39.9446 15.3691 34.747 14.908 33.0654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.82 53.5501C25.82 53.5501 26.4348 64.7096 17.2134 67.7671C19.8261 59.512 21.0556 57.0661 25.82 53.5501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22145 78.6209C9.22145 78.6209 16.1375 80.3024 19.2114 69.9072C15.3691 70.9773 11.0657 73.8819 9.22145 78.6209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0617 65.474C15.0617 65.474 21.9778 55.996 16.1375 50.1869C15.9838 51.8685 11.9879 59.0534 15.0617 65.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2953 64.251C12.2953 64.251 15.9839 70.5187 8.29934 75.2577C8.29934 72.2003 7.99192 70.5187 12.2953 64.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07585 84.8885C1.07585 84.8885 7.22345 86.1115 10.451 80.4553C8.45298 80.6082 4.45705 79.0795 1.07585 84.8885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84431 81.0668C1.84431 81.0668 7.37718 78.9266 6.45503 73.5761C5.68658 74.1876 1.69062 76.0221 1.84431 81.0668Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightbracket);
export default __webpack_public_path__ + "static/media/Rightbracket.487e9c5a1c936750e9e6e60fcf2692ee.svg";
export { ForwardRef as ReactComponent };